import { CateringTranslations } from "./catering-pt-br";

export const CATERING_EN_US: CateringTranslations = {
	title: "Catering",
	description: "List and configure items used in catering proposals services",
};
